<template>
  <page>
    <profile-nav class="mb-3" v-if="isEnglishLang"/>
    <b-row v-if="company" class="mb-5">
      <b-col cols="12" md="10" offset-md="1">
        <div class="mb-5 text-center">
          <h3>{{ $t('onboarding.sync-connections.title') }}</h3>
          <h4>{{ $t('onboarding.sync-connections.description') }}</h4>
        </div>

        <contacts-upload-promo class="my-5"/>

        <contacts-upload-container class="p-0 my-5" :preferences="company.networkPreferences"
          :preSelect="preSelectedUploadProvider" :redirectUriTemplate="redirectUriTemplate"/>

        <contacts-upload-privacy/>

        <b-row>
          <b-col class="d-flex justify-content-end align-items-center px-3">
            <b-button href="/dashboard" class="px-5" variant="primary">Done</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </page>
</template>

<script>
import Page from '@/components/Page';
import ProfileNav from '@/components/users/ProfileNav';
import RegisterNetworkQuery from '@/graphql/queries/RegisterNetwork.gql';
import ContactsUploadContainer from '@/components/contacts-upload/Container';
import ContactsUploadPromo from '@/components/contacts-upload/Promo';
import ContactsUploadPrivacy from '@/components/contacts-upload/Privacy';
import { mapRoot } from '@src/mixins/root';

export default {
  components: {
    Page,
    ProfileNav,
    ContactsUploadContainer,
    ContactsUploadPromo,
    ContactsUploadPrivacy,
  },
  metaInfo: {
    title: 'Sync Contacts',
  },
  apollo: {
    company: {
      query: RegisterNetworkQuery,
      error(err) {
        this.fatalErr = err;
      },
    },
  },
  computed: {
    ...mapRoot([ 'isEnglishLang' ]),
    redirectUriTemplate() {
      return `${this.$root.origin}${this.$route.path}?provider=$PROVIDER`;
    },
    preSelectedUploadProvider() {
      if (this.$route && this.$route.query && this.$route.query.provider) {
        return this.$route.query.provider;
      } else {
        return null;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/User/SyncContacts.vue